import defaults from "lodash/defaults";
import {
  getPermissionNamesByIds,
  getRoleNameById,
} from "../../dashboard/settings/manage-coaches/utils/manage-coaches-utils";
import CustomWorkflows from "./screens/CustomWorkflows";
import { GettingStarted } from "./screens/GettingStarted";
import WelcomeVideo from "./modals/welcome-video";
import LinkProgram from "./modals/link-program";
import SetYourGoals from "./modals/set-your-goals";
import IntegrateYourApp from "./modals/integrate-your-app";
import SelectMacroCalculator from "./modals/select-macro-calculator";
import SelectVideoPlaylist from "./modals/select-video-playlist";
import SelectGuides from "./modals/select-guides";
import SelectMealPlanLibrary from "./modals/select-meal-plan-library";
import SelectDailyAccountabilityTemplates from "./modals/select-daily-accountability-templates";
import AddContract from "./modals/add-contract";
import CreateQuestionnaire from "./modals/create-questionnaire";
import ActivityDrawer from "../../../parts/activity-drawer/ActivityDrawer";

const CustomWorkflowsController = async ({ res, req, locals, load }) => {
  const { query = {} } = req;
  const modal = query.modal || {};
  const {
    activeUser,
    organizationOwner,
    organizationRoles,
    organizationPermissions: globalOrganizationPermissions = [],
  } = locals;
  const { organizationId, organizationPermissions = [] } = activeUser;
  //User's permissions (if it's part of an organization, if not, we only are giving a empty array)
  const userOrganizationPermission =
    organizationPermissions.length > 0
      ? getPermissionNamesByIds(
          globalOrganizationPermissions,
          organizationPermissions
        )
      : [""];
  const roleName = activeUser.organizationRoleId
    ? getRoleNameById(organizationRoles, activeUser.organizationRoleId)
    : "Owner";

  const userToBindInformation =
    roleName === "Owner" ? activeUser : organizationOwner;

  const isPushCoach = Boolean(userToBindInformation.pushAccountInfo);
  const userCanAccessToPush =
    (!organizationId && isPushCoach) ||
    (isPushCoach &&
      !!organizationId &&
      userOrganizationPermission.includes("PUSH"));
  const userOrganizationCanAccessToWorkflows =
    !organizationId ||
    (!!organizationId &&
      userOrganizationPermission.includes("Custom Workflows"));

  defaults(query, {
    access:
      userCanAccessToPush && userOrganizationCanAccessToWorkflows
        ? "push"
        : "pull",
  });
  const access = query.access ?? "push";

  await load("workflows");

  if (query.workflow && locals.workflows) {
    locals.workflow = locals.workflows.find(
      ({ _id }) => _id === query.workflow
    );
  }

  switch (modal.type) {
    case "macroCalculator":
      await load("macroCalculators", { access });
      break;
    case "videos":
      await load("videoPlaylistWidgets", { access });
      break;
    case "guides":
      await load("guidesWidgets", { access });
      break;
    case "mealPlan":
      await load("mealPlanWidgets", { access });
      break;
    case "accountabilities":
      await load("accountabilityWidgets", { access });
      break;
    default:
      break;
  }

  const sections = {
    main: (
      <CustomWorkflows
        userCanAccessToPush={userCanAccessToPush}
        userOrganizationCanAccessToWorkflows={
          userOrganizationCanAccessToWorkflows
        }
      />
    ),
    "getting-started": <GettingStarted />,
  };

  locals.modal = {
    welcomeVideo: <WelcomeVideo workflow={locals.workflow} />,
    program: (
      <LinkProgram
        workflow={locals.workflow}
        explanationAdded={query.explanationAdded}
      />
    ),
    goals: (
      <SetYourGoals
        workflow={locals.workflow}
        explanationAdded={query.explanationAdded}
      />
    ),
    integrations: <IntegrateYourApp workflow={locals.workflow} />,
    macroCalculator: (
      <SelectMacroCalculator
        workflow={locals.workflow}
        explanationAdded={query.explanationAdded}
        macroCalculators={locals.macroCalculators}
      />
    ),
    videos: (
      <SelectVideoPlaylist
        workflow={locals.workflow}
        videoPlaylistWidgets={locals.videoPlaylistWidgets}
      />
    ),
    guides: (
      <SelectGuides
        workflow={locals.workflow}
        explanationAdded={query.explanationAdded}
        guidesWidgets={locals.guidesWidgets}
      />
    ),
    mealPlan: (
      <SelectMealPlanLibrary
        workflow={locals.workflow}
        mealPlanWidgets={locals.mealPlanWidgets}
        explanationAdded={query.explanationAdded}
      />
    ),
    accountabilities: (
      <SelectDailyAccountabilityTemplates
        workflow={locals.workflow}
        accountabilityWidgets={locals.accountabilityWidgets}
        explanationAdded={query.explanationAdded}
      />
    ),
    contract: <AddContract workflow={locals.workflow} />,
    questionnaire: (
      <CreateQuestionnaire workflow={locals.workflow} locals={locals} />
    ),
    "activity-feed": <ActivityDrawer />,
  }[modal.type];

  res.body = sections[query.type] || sections.main;
};

export default CustomWorkflowsController;
